import { SVGProps } from "react"

export const ReverIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 22" fill="currentColor" {...props}>
      <text x="0" y="17" fontFamily="sans-serif" fontWeight="800" fontSize="18" letterSpacing="3">
        {"REVER"}
      </text>
    </svg>
  )
}
